module.exports = { "default": require("core-js/library/fn/object/get-own-property-symbols"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/get-own-property-symbols.js
// module id = 38
// module chunks = 0